

import React, { useState } from 'react';
import { Box, Menu, MenuItem, CircularProgress } from '@mui/material';
import CustomText, { textStyles } from './CustomText';
import arrow from "../assets/arrow.svg";
import { showUnderDevelopment } from './alerts';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';

import { useTranslation } from 'react-i18next';
const ExportDropdown = ({ onDownloadPDF ,onDownloadExcel }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    setLoading(true);

    // Simulate loading for 1 second before calling the actual download
    setTimeout(() => {
      setLoading(false);
      handleClose();
      onDownloadPDF();
    }, 1000);
  };
  const { t } = useTranslation();


  


  return (
    <Box>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1.4,
          height: 34,
          py: 0.4,
          borderRadius: '4px',
          backgroundColor: '#091E420F',
          cursor: 'pointer',
          minWidth: 100,
          justifyContent: 'center'
        }}
      >
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 600,
            fontSize: '12px',
            color: '#172B4D',
            textAlign: 'center'
          }}
        >
             {t('ExportDropdown.export')}
        </CustomText>
        <img src={arrow} alt="arrow" />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '4px',
            mt: 0.5,
            width: 100,
            backgroundColor: '#fff',
            boxShadow: 'none',
            border: '1px solid #E4E6EF',
          },
        }}
        MenuListProps={{
          sx: {
            px: 0.5,
            py: 0.5,
          }
        }}
      >
        <MenuItem
  onClick={handleDownload}
  sx={{
    fontSize: '13px',
    fontFamily: 'Poppins, sans-serif',
    py: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  }}
>
  {loading ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <CircularProgress size={16} thickness={5} sx={{ color: '#006EC2' }} />
      <span style={{ fontSize: '13px', color: '#6B7280' }}>
        PDF
      </span>
    </Box>
  ) : (
    <>
      <PictureAsPdfIcon sx={{ color: '#D32F2F', fontSize: 20 }} /> {/* Red like PDF */}
     PDF
    </>
  )}
</MenuItem>


  <MenuItem
          onClick={() => {
            if (onDownloadExcel) onDownloadExcel();
            handleClose();
          }}
          sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif", py: "8px", display: "flex", alignItems: "center", gap: 1 }}
        >
          <TableChartIcon sx={{ color: "#2E7D32", fontSize: 20 }} />
          Excel
        </MenuItem>


      </Menu>
    </Box>
  );
};

export default ExportDropdown;



